import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'

interface CreateCostItemOptions {
  drsId: string,
  roleId: string,
  itemDescription: string,
  itemPrice: number,
  planItemPrice?: number | null,
  category?: number,
}

export const apiDRSCostItemCreate = ({
  drsId,
  roleId,
  itemDescription,
  itemPrice,
  planItemPrice,
  category,
}: CreateCostItemOptions) => {
  const options = {
    method: 'POST',
    url: `${BASE_API_URL}/drs/${drsId}/costItems`,
    params: {
      role: roleId,
      reqDev: 'web',
    },
    data: {
      itemDescription,
      itemPrice,
      planItemPrice,
      category,
    },
  }
  return ax(options)
}
